import React from "react";
import { Container, Card } from "react-bootstrap";
import "./terms.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-page py-5">
      <Container>
        <Card className="terms-card p-4 shadow-lg rounded-4">
          <h2 className="text-center mb-3"> Terms and Conditions</h2>
          <p className="intro text-center">
 Welcome to <strong>VAIBHAVAM</strong>, a product of{" "}
            <strong>BION Technology Solution</strong>. By accessing and using
            our website/platform, you agree to the following terms and
            conditions. Please read them carefully. We may update or revise
            these terms from time to time, and continued use of our services
            constitutes acceptance of those changes.

          </p>

          <div className="terms-section">
            <h4>1. Eligibility to use our Platform</h4>
            <p>
           Our services are available only to individuals who can legally
              enter into contracts under applicable laws. If you are under the
              age of 18 years, you may use our services only with the
              involvement of a parent or legal guardian.

            </p>
          </div>

          <div className="terms-section">
            <h4>2. Service Usage</h4>
            <p>
            <strong>VAIBHAVAM</strong> acts as a service platform connecting
              customers with <strong>wedding venues</strong> and{" "}
              <strong>vendors</strong>. We do not sell products directly.
              Instead, we enable you to explore, compare, and connect with
              trusted service providers for your wedding needs.
            </p>
          </div>

          <div className="terms-section">
            <h4>3. Electronic Communications</h4>
            <p>
          By using our site or communicating with us via email or other
              channels, you consent to receive communications from us
              electronically. All agreements, notices, and communications will
              be provided electronically and will satisfy any legal requirements
              that such communications be in writing.
            </p>
          </div>

          <div className="terms-section">
            <h4>4. User Responsibilities</h4>
            <p>
          You agree to use <strong>VAIBHAVAM</strong> only for lawful
              purposes. You are responsible for ensuring the accuracy of the
              information you provide while booking venues or vendor services.
              Any misuse of the platform, including false inquiries, abusive
              content, or spamming, may result in termination of your access.
            </p>
          </div>

          <div className="terms-section">
            <h4>5. Accuracy of Information</h4>
            <p>
            While we strive to ensure that all details about venues and
              vendors are accurate and up to date,{" "}
              <strong>VAIBHAVAM</strong> does not guarantee the accuracy,
              completeness, or reliability of the information. Final terms,
              pricing, and services are subject to confirmation directly with
              the vendor or venue.
            </p>
          </div>

      
        </Card>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
